const externalGutter = {
  mobile: "xsmall",
  tablet: "gutter",
  desktop: "xlarge"
};
export {
  externalGutter
};
